var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header-bg-variant":"warning","header":"Avatar"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('avatar-image',{attrs:{"avatar":_vm.avatar}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }